import { apiService } from '../../..'
import { DeleteSessionRequest, GetSessionsResponseBody } from '../types'

const baseURL = '/portal/consumers/sessions'

export const sessionService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getSessions: build.query<GetSessionsResponseBody, void>({
      query: () => {
        return {
          url: baseURL,
          method: 'GET',
        }
      },
      providesTags: ['Sessions'],
    }),
    deleteSession: build.mutation<void, DeleteSessionRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/${req.params.type}/${req.params.id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: ['Sessions'],
    }),
  }),
})
